import { graphql } from "gql.tada";
import { LinkFragment } from "./LinkFragment";
import { FootnoteFragment } from "./FootnoteFragment";

export const SlideCarouselSectionFragment = graphql(
  `
    fragment SlideCarouselSectionFragment on SlideCarouselSection {
      sys {
        id
      }
      title
      description
      variant
      navPosition
      progressStyle
      cta {
        ...LinkFragment
      }
      itemsCollection(limit: 10) {
        items {
          sys {
            id
          }
          category
          title
          description {
            json
            links {
              entries {
                inline {
                  sys { id }
                  __typename
                  ... on Footnote {
                    ...FootnoteFragment
                  }
                }
              }
            }
          }
          advertisingTopic
          publishedDate
          image {
            url
            title
            contentType
          }
          videoLink {
            ...LinkFragment
          }
          ctaLink {
            ...LinkFragment
          }
        }
      }
    }
  `,
  [LinkFragment, FootnoteFragment]
);
